import Layout from '@/layout'

const securityRouter = {
  path: '',
  component: Layout,
  redirect: 'security',
  name: '安全中心',
  meta: {
    title: '安全中心',
    icon: 'el-icon-s-home'
  },
  children: [{
    path: 'security',
    name: 'security',
    meta: {
      title: '安全中心'
    },
    component: () => import('@/views/security')
  },
  {
    path: 'security/setEncrypted',
    name: 'setEncrypted',
    meta: {
      title: '设置密保问题'
    },
    component: () => import('@/views/security/setEncrypted')
  },
  {
    path: 'security/editEncrypted',
    name: 'editEncrypted',
    meta: {
      title: '修改密保问题'
    },
    component: () => import('@/views/security/editEncrypted')
  },
  {
    path: 'security/modification',
    name: 'modification',
    meta: {
      title: '通过密保修改密保问题'
    },
    component: () => import('@/views/security/modification')
  },
  {
    path: 'security/modificationByPhone',
    name: 'modificationByPhone',
    meta: {
      title: '通过手机修改密保问题'
    },
    component: () => import('@/views/security/modificationByPhone')
  },
  {
    path: 'security/modificationByPwd',
    name: 'modificationByPwd',
    meta: {
      title: '通过密码修改密保问题'
    },
    component: () => import('@/views/security/modificationByPwd')
  },
  {
    path: 'security/editPassword',
    name: 'editPassword',
    meta: {
      title: '修改支付密码'
    },
    component: () => import('@/views/security/editPassword')
  },
  {
    path: 'security/setPassword',
    name: 'setPassword',
    meta: {
      title: '设置支付密码'
    },
    component: () => import('@/views/security/setPassword')
  },
  {
    path: 'security/editLoginPassword',
    name: 'editLoginPassword',
    meta: {
      title: '修改登陆密码'
    },
    component: () => import('@/views/security/editLoginPassword')
  },
  {
    path: 'security/setLoginPassword',
    name: 'setLoginPassword',
    meta: {
      title: '设置登陆密码'
    },
    component: () => import('@/views/security/setLoginPassword')
  },
  {
    path: 'security/editPhone',
    name: 'editPhone',
    meta: {
      title: '修改手机号'
    },
    component: () => import('@/views/security/editPhone')
  },
  {
    path: 'security/findPay',
    name: 'findPay',
    meta: {
      title: '找回支付密码'
    },
    component: () => import('@/views/security/findPay')
  },
  {
    path: 'security/outSignNow',
    name: 'outSignNow',
    meta: {
      title: '立即注销'
    },
    component: () => import('@/views/security/outSignNow')
  }
  ]
}

export default securityRouter
